const headerTransform = () => {
	// Hidden pixel
	const headerEl = document.querySelector('#headerPX');
	const headerCtaBlock = document.querySelector('.header-cta-block-area');
	const checkoutPage = document.querySelector('body.checkout');

	if (!headerEl || !headerCtaBlock || checkoutPage) {
		return;
	}

	document.body.classList.add('header-cta');

	const options = {
		rootMargin: '100px 0px 0px 0px',
		threshold: 0
	};

	const callback = (entries, observer) => {
		entries.forEach((entry) => {
			// console.log(entry.isIntersecting);
			if (entry.isIntersecting) {
				document.body.classList.remove('header-cta-visible');
			} else {
				document.body.classList.add('header-cta-visible');
			}
		});
	};

	const observer = new IntersectionObserver(callback, options);

	observer.observe(headerEl);
};

export default headerTransform;